import { useStore } from '@/stores';
import { useAccountGroup } from '@/features/account-group/api/use-account-group';

export function useIsSubBusiness(): boolean {
  const profile = useStore((state) => state.profile);
  const selectedBusiness = useStore((state) => state.selectedBusiness);

  const isMainGroup = profile?.is_group === true && profile?.business_group_status === 'main';

  const { data: accountGroupData } = useAccountGroup(
    { page: 1, limit: 1 },
    { enabled: isMainGroup && selectedBusiness !== null },
  );

  const mainBusinessId = accountGroupData?.data?.main_business_id;
  const ownBusinessId = profile?.business.id ? String(profile.business.id) : null;

  const isViewingOther = selectedBusiness !== null && selectedBusiness.id !== ownBusinessId;
  const isViewingMain =
    mainBusinessId !== undefined && selectedBusiness?.id === String(mainBusinessId);

  return isViewingOther && !isViewingMain && selectedBusiness !== null;
}
